export default __webpack_public_path__ + "static/media/horizontal_white_leaf.db16010d.svg";